module.exports = __webpack_public_path__ + "static/media/corelogic-logo.f5dd91c1.svg";